/**
 * Replaces the content of a Froala editor as one undoable step: Ctrl+Z brings
 * the previous text back.
 *
 * Changing the content through the React model would reset the undo history
 * instead (see setNormalTagContent in FroalaEditorFunctionality). The change
 * event that Froala fires for the second saveStep reports the new content to
 * the model, so the model is not out of date afterwards.
 *
 * Returns the html as the editor holds it now. Froala may normalize what it is
 * given, and this is what its change event reports, so callers can recognise
 * that event as the echo of their own change.
 */
export function replaceContentKeepingUndo(editor, html) {
  // the text before the change must be a step of its own
  editor.undo.saveStep();
  editor.html.set(html);
  editor.undo.saveStep();

  return editor.html.get();
}
